import axios from "axios";
import stringify from "qs/lib/stringify";
import { type OldProductSpecItem } from "./OldProductSpecItem";
import { type IProductSpecMultiUpdater, type IProductSpecItem } from "../..";
import { replaceElement } from "../../replaceElement";

export class OldProductSpecMultiUpdater implements IProductSpecMultiUpdater {
    async update(specItems: IProductSpecItem[]): Promise<void> {
        if (specItems.length == 0) return;

        const $: any = (<any>window).$;

        const firstItem = specItems[0] as OldProductSpecItem;

        const url = "/ajax/SingleProductSpecs/";
        const data: any = {
            partialViewName: firstItem.getPartialViewName(),
            returnNullIfProductInactive: firstItem.getIsInList(),
        };

        for (let i = 0; i < specItems.length; i++) {
            const specItem = specItems[i] as OldProductSpecItem;
            const arrayIndex = "[" + i + "]";

            data["id" + arrayIndex] = specItem.getItemId();
            data["updated" + arrayIndex] = specItem.stamp;

            const optionalAuctionId = specItem.getOptionalAuctionId();
            if (optionalAuctionId != null)
                data["optionalAuctionId" + arrayIndex] = optionalAuctionId;
            const optionalAuctionPredefined =
                specItem.getOptionalAuctionPredefined();
            if (optionalAuctionPredefined != null)
                data["optionalAuctionPredefined" + arrayIndex] =
                    optionalAuctionPredefined;
            const currentAuctionIdInt = parseInt(
                specItem.getCurrentAuctionId()
            );
            if (!isNaN(currentAuctionIdInt))
                data["currentAuctionId" + arrayIndex] = currentAuctionIdInt;
        }

        const response = await axios.post(url, stringify(data));
        const result = response.data;

        if (!result) throw new Error("Result returned null");

        const $result = $(result);
        for (let i = 0; i < specItems.length; i++) {
            const specItem = specItems[i] as OldProductSpecItem;

            const itemId = specItem.getItemId();
            const itemType = specItem.getItemType();

            const itemsWithSameId = specItems.filter(function (x) {
                return (x as OldProductSpecItem).getItemId() == itemId;
            });

            const thisItemIndex = itemsWithSameId.indexOf(specItem);

            let $resultItem = $result.filter(
                ".specsToUpdate[data-item-id='" +
                    itemId +
                    "'][data-item-type='" +
                    itemType +
                    "']",
                $result
            );

            if ($resultItem.length === 0) continue;

            if ($resultItem.length > 1) {
                $resultItem = $resultItem.eq(thisItemIndex);
            }

            const itemSpecsElement = specItem.specsContainer;

            replaceElement($resultItem, itemSpecsElement, itemId, itemType);
        }
    }
}
